import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {CopilotChatRepo} from '@github-ui/copilot-chat-types'

import {copilotChatRepositoryPath} from './api-url-helpers'

/**
 * Fetches repository details from the GitHub Copilot chat API.
 *
 * @param repoID - The ID of the repository to fetch
 * @returns Promise containing the repository details
 * @throws Error if the fetch fails or returns a non-ok response
 */
export async function fetchRepo(repoID: number): Promise<CopilotChatRepo> {
  const res = await verifiedFetchJSON(copilotChatRepositoryPath(repoID), {method: 'GET'})

  if (!res.ok) {
    throw new Error(`Failed to fetch repository details: ${res.status}`)
  }

  const payload = await res.json()
  return payload
}
